import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import {KundengruppeKundengrpListView} from "./list-view/kundengruppe-kundengrp.list-view";

export const kundengruppeKundengrpFieldOk: FieldOkConfig = {
  name: 'kundengruppe.kundengrp',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kundengrp}} - {{bezeichnung1}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: KundengruppeKundengrpListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};
export const kundengruppeKundengrpMultiSelectFieldOk: FieldOkConfig = {
  name: 'kundengruppe.kundengrp',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kundengrp}} - {{bezeichnung1}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: KundengruppeKundengrpListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};

export const kundengruppeKundengrpQueryFieldOk: FieldOkConfig = {
  name: 'kundengruppe.kundengrp',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kundengrp}} - {{bezeichnung1}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: KundengruppeKundengrpListView,
      sort: {
        properties: [
          {property: 'objekt', title: 'Objekt'},
        ]
      }
    }
  }
  ]
};
